export default __webpack_public_path__ + "media/react/pages/payment_flows/add_ons/assets/admissions/headshot_taryn-abb79b4a89e4df6738a5108e879dee56.jpg";